import React, { useEffect, useState } from "react";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import ProgressBar from "../../ProgressBar/ProgressBar";
import pickDocumentIcon from "../../../assets/icons/progress/icon_progressbar_vertrag_upload.svg";
import furtherDocumentsIcon from "../../../assets/icons/progress/icon_progressbar_add_documents.svg";
import addNoteIcon from "../../../assets/icons/progress/icon_progressbar_letter.svg";
import finishedIcon from "../../../assets/icons/progress/icon_progressbar_finished.svg";
import StepSwitch from "./StepSwitch";
import { getFinishedStep, getMainAttachmentStep, getMessageStep } from "../../../services/messagingService";
import { MessageCreateData } from "../../../types/Messaging/MessageCreateData";
import useMediaObjectCombinationRequest from "../../../hooks/useMediaObjectCombinationRequest";
import MessageFormLoader from "@/src/components/Messaging/MessageForm/MessageFormLoader";

//progressbar step indices
const MESSAGE = 0;
const ATTACHMENT = 1;
const FURTHER_ATTACHMENTS = 2;
const FINISHED = 3;

const progressBarSteps = [
  {
    key: "note",
    name: "Nachricht verfassen",
    icon: addNoteIcon,
    progress: 15,
  },
  {
    key: "mainDocument",
    name: "Datei anhängen",
    icon: pickDocumentIcon,
    progress: 40,
  },
  {
    key: "furtherDocuments",
    name: "Weitere Dateien",
    icon: furtherDocumentsIcon,
    progress: 65,
  },
  {
    key: "finished",
    name: "Nachricht versenden",
    icon: finishedIcon,
    progress: 100,
  },
];

type MessageFormProps = {
  product: AbstractCase;
};

export default function MessageForm({ product }: MessageFormProps) {
  const [steps, setSteps] = useState(4);
  const [currentStep, setCurrentStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [messageCreateData, setMessageCreateData] = useState<MessageCreateData | null>(null);

  const { mediaObjectCombinationRequests, isLoadingMediaObjectCombinationRequest, updateAction } = useMediaObjectCombinationRequest(product, ["message"]);
  const getProgressBarStep = () => {
    switch (currentStep) {
      case getMessageStep():
        return progressBarSteps[MESSAGE];
      case getMainAttachmentStep():
        return progressBarSteps[ATTACHMENT];
      case getFinishedStep(steps):
        return progressBarSteps[FINISHED];
      default:
        return progressBarSteps[FURTHER_ATTACHMENTS];
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  const progressBarStep = getProgressBarStep();

  return (
    <>
      <ProgressBar steps={progressBarSteps} active={progressBarStep.key} progress={progressBarStep.progress} />
      {isLoading || isLoadingMediaObjectCombinationRequest ? (
        <MessageFormLoader />
      ) : (
        <StepSwitch
          messageCreateData={messageCreateData}
          setMessageCreateData={setMessageCreateData}
          currentStep={currentStep}
          product={product}
          setCurrentStep={setCurrentStep}
          steps={steps}
          setSteps={setSteps}
          setIsLoading={setIsLoading}
          mediaObjectCombinationRequest={mediaObjectCombinationRequests.message}
          mediaObjectCombinationRequestUpdateAction={updateAction}
        />
      )}
    </>
  );
}
